<template>
  <div v-if="list.length > 0" class="tabBlock">
    <scroll-view
      scroll-x="true"
      scroll-with-animation
      :scroll-left="tabsScrollLeft"
      @scroll="scroll"
    >
      <div id="tab_list" class="tab">
        <div
          v-for="(item, index) in list"
          id="tab_item"
          :key="index"
          :class="['tab__item', { 'tab__item--active': currentIndex === index }]"
          :style="{ color: currentIndex === index ? `${itemColor}` : '' }"
          @click="select(item, index)"
        >
          <div class="tab__item-title">
            <slot name="value" :value="item.value" :item="item"></slot>
          </div>
          <div v-if="!showTitleSlot" class="tab__item-title">
            {{ item.value }}
          </div>
        </div>
      </div>
      <div
        class="tab__line"
        :style="{
          background: lineColor,
          width: lineStyle.width,
          transform: lineStyle.transform,
          transitionDuration: lineStyle.transitionDuration
        }"
      />
    </scroll-view>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: [Number, String],
    list: {
      // 传值
      type: Array,
      default: () => {
        return []
      }
    },
    itemColor: String, // tab主色调
    lineColor: String, // 下划线主色调
    lineAnimated: {
      // 是否展示下划线动画
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      lineStyle: {},
      scrollLeft: 0,
      tabsScrollLeft: 0,
      duration: 0.3
    }
  },
  computed: {
    showTitleSlot() {
      return this.$slots && this.$slots.title
    }
  },
  watch: {
    list() {
      this.setTabList()
    },
    modelValue() {
      this.currentIndex = this.modelValue
      this.setTabList()
    }
  },
  mounted() {
    this.currentIndex = this.modelValue || 0
    this.setTabList()
    if (!this.lineAnimated) {
      this.duration = 0
    }
  },
  methods: {
    select(item, index) {
      this.$emit('update:modelValue', index)
    },
    setTabList() {
      this.$nextTick(() => {
        if (this.list.length > 0) {
          this.setLine()
          this.scrollIntoView()
        }
      })
    },
    setLine() {
      let lineWidth = 0,
        lineLeft = 0
      this.getElementData(`#tab_item`, data => {
        const el = data[this.currentIndex]
        lineWidth = el.width / 2
        // lineLeft = el.width * (this.currentIndex + 0.5)  // 此种只能针对每个item长度一致的
        lineLeft = el.width / 2 + -data[0].left + el.left
        this.lineStyle = {
          width: `${lineWidth}px`,
          transform: `translateX(${lineLeft}px) translateX(-50%)`,
          transitionDuration: `${this.duration}s`
        }
      })
    },
    scrollIntoView() {
      // item滚动
      let lineLeft = 0
      this.getElementData('#tab_list', data => {
        const list = data[0]
        this.getElementData(`#tab_item`, data => {
          const el = data[this.currentIndex]
          // lineLeft = el.width * (this.currentIndex + 0.5) - list.width / 2 - this.scrollLeft
          lineLeft = el.width / 2 + -list.left + el.left - list.width / 2 - this.scrollLeft
          this.tabsScrollLeft = this.scrollLeft + lineLeft
        })
      })
    },
    getElementData(el, callback) {
      const doms = document.querySelectorAll(el)
      const rects = []
      for (let item of doms) {
        const rect = item.getBoundingClientRect()
        rects.push(rect)
      }
      callback(rects[0])
    },
    scroll(e) {
      this.scrollLeft = e.detail.scrollLeft
    }
  }
}
</script>

<style lang="scss">
.tabBlock {
  position: relative;
  background: #fff;
  border-bottom: 0.021333rem solid #ddd;
  .tab {
    position: relative;
    display: flex;
    font-size: 0.597333rem;
    white-space: nowrap;
    &__item {
      width: 4.266667rem;
      text-align: center;
      line-height: 1.706667rem;
      color: #333;
      &--active {
        color: $uni-color-primary;
      }
      &-title {
        margin: 0;
      }
    }
  }
  .tab__line {
    display: block;
    height: 0.085333rem;
    position: absolute;
    bottom: 0.085333rem;
    left: 0;
    z-index: 1;
    border-radius: 0.064rem;
    position: relative;
    background: $uni-color-primary;
  }
}
</style>
